import { number, struct } from 'io-ts/Decoder';

import { iotsUtils } from '@bedc/core';

import { Type as Change } from '../../../../job/hitlv2/change/Type';

export const RequestItem = struct({
	pageNumber: iotsUtils.PositiveInteger1Based,
	/** For optimistic concurrency - must match server version */
	version: number,
	/** Finer-grained change messages - Array of individual change messages (segment-removed, frame-deleted, etc.) */
	changes: iotsUtils.NonEmptyArray(Change),
});
